import t from 'format-message';
const validate = (values) => {
    let errors = {};
    if (!values.email) {
        errors.email = t('Required');
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(values.email)) {
        errors.email = t('Invalid email address');
    }
    if (!values.password) {
        errors.password = t('Required');
    }
    return errors;
};
export default validate;
//# sourceMappingURL=logInValidator.js.map